import { useQuery } from '@tanstack/react-query';
import { SoarQueryKeys } from '../queryKeys';
import { playbookService } from '../services/playbookService';

export const useTemplates = () => {
  const {
    data: templates = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: [SoarQueryKeys.TEMPLATES],
    queryFn: () => playbookService.getPlaybookTemplates(),
  });

  return { templates, isLoading, error };
};
